"use client";

import React, { useEffect, useState, useRef } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const hubs = [{
  top: "28%",
  left: "22%"
}, {
  top: "32%",
  left: "28%"
}, {
  top: "25%",
  left: "48%"
}, {
  top: "22%",
  left: "52%"
}, {
  top: "42%",
  left: "58%"
}, {
  top: "35%",
  left: "75%"
}, {
  top: "45%",
  left: "70%"
}, {
  top: "75%",
  left: "85%"
}, {
  top: "65%",
  left: "32%"
}];
export default function GlobalPresence() {
  const [offsetY, setOffsetY] = useState(0);
  const sectionRef = useRef<HTMLElement>(null);
  const {
    ref: textRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;
      const rect = sectionRef.current.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      if (rect.top < viewportHeight && rect.bottom > 0) {
        const scrolled = window.scrollY;
        setOffsetY(scrolled * 0.15);
      }
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section id="global-presence" ref={sectionRef} className="relative w-full h-[500px] md:h-[600px] lg:h-[700px] bg-background overflow-hidden flex items-center justify-center border-y border-border/40">
      {}
      <div className="absolute inset-0 w-full h-[130%] -top-[15%] pointer-events-none transition-transform duration-75 ease-out" style={{
      transform: `translateY(${offsetY}px)`
    }}>
        {}
        <div className="absolute inset-0 w-full h-full opacity-40 mix-blend-multiply dark:mix-blend-soft-light">
          <div className="w-full h-full bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1589716/img/abstract_world_map_navy_lines.png')] bg-contain bg-center bg-no-repeat" />
        </div>

        {}
        <div className="absolute inset-0 max-w-7xl mx-auto w-full h-full relative">
          {hubs.map((hub, i) => <div key={i} data-index={i} className="absolute w-2 h-2 md:w-3 md:h-3 bg-secondary rounded-full animate-pulse" style={{
          top: hub.top,
          left: hub.left,
          boxShadow: "0 0 15px 4px var(--color-secondary)"
        }}>
              {}
              <div className="absolute inset-0 bg-white rounded-full opacity-50 scale-50" />
            </div>)}
        </div>
      </div>

      {}
      <div ref={textRef} className={`relative z-10 text-center px-6 max-w-4xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="inline-block mb-4 px-4 py-1.5 rounded-full bg-primary/10 border border-primary/20 backdrop-blur-sm">
          <span className="text-sm font-medium text-primary tracking-wider uppercase">
            Global Reach
          </span>
        </div>
        <h2 className="text-4xl font-serif tracking-tight mb-6 leading-tight !text-[hsl(38,92%,50%)] md:text-5xl lg:text-6xl">Built For Global</h2>
        <p className="text-lg font-sans max-w-2xl mx-auto leading-relaxed !font-medium !text-[hsl(210,10%,23%)] md:text-xl">Operating across time zones, building authority for leaders who think beyond local markets.</p>
      </div>
      
      {}
      <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-background to-transparent pointer-events-none" />
      <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-background to-transparent pointer-events-none" />
    </section>;
}